import React from 'react';
import BadgeNewProduct from './BadgeNewProduct';
import BadgeProductSale from './BadgeProductSale';
import BadgeProductTagFlag from './BadgeProductTagFlag';

interface TitleProductProps {
    product: any;
    show?: boolean;
    className?: string;
}

const TitleProduct = ({
    product,
    show=true,
    className=''
}: TitleProductProps) => {
    return (
        <h2 className={`
            ${className}
            transition-all ease-in-out duration-200
            flex gap-1 items-center
            font-extrabold
            text-2xl
            leading-none
            text-shopfood-title
            transiton-opacity
            ${show ? 'opacity-100 max-h-max' : 'opacity-0 h-0'}`
        }
        >
            <span>
                {product.name}

                {/* PRODUCT TAG FLAG  */}
                <BadgeProductTagFlag product={product} className='inline-block ml-1.5' />
            </span>

            {/* BADGE FOR NEW PRODUCT ON CATALOG */}
            <BadgeNewProduct product={product} className='absolute top-0 right-3 rounded-b' />

            {/* PRODUCT SALE  */}
            <BadgeProductSale product={product} className='absolute top-0 right-3 rounded-b' />
        </h2>
    );
};

export default TitleProduct;
